import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import parse from 'html-react-parser';
import React, { useRef } from 'react';
import tinycolor from 'tinycolor2';
import getColor, { getColorHex } from '../../utils/ColorUtils';
import parseLinkOption from '../../utils/LinkUtils';
import VideoPlayer from '../global/VideoPlayer';
import WebFrame from '../global/WebFrame';
import ComponentBg from './ComponentBg';
import {
  figcaption,
  imgWrapper,
  multiImgFlex,
  portraitImg,
} from './MediaWrapper.module.scss';

const MediaWrapper = ({ media }) => {
  // Storing CSS vars. See below for explanation.
  const aspectRatiosRef = useRef([]);

  // Create a ref for scoping GSAP background animation selectors
  const imgContextRef = useRef();

  const bgColor = getColor(media[0].background_color); // Returns variable name or hex
  const bgColorHex = getColorHex(media[0].background_color); // Returns only hex

  // Check if the hex bg color is light, for caption text color
  const lightBg = tinycolor(bgColorHex).isLight();

  return (
    <div className={``} ref={imgContextRef}>
      <div
        className={`bgColorTrigger bgWidthTrigger posRel pagePadding pagePaddingWide pageGrid sectionVertPadding`}
        data-id={media[0].id}
        data-width="wide"
      >
        <ComponentBg
          id={media[0].id}
          widthTrigger={`.bgWidthTrigger`}
          color={bgColor}
          // markers
        />
        <div className={`scrollFast gridAllColumns ${multiImgFlex} `}>
          {media.map(
            (
              {
                strapi_component,
                autoplay,
                caption,
                content,
                frame,
                is_vr,
                video_cover,
                video_description,
                link_content,
                local_filename
              },
              index
            ) => {
              // Destructuring images
              const { localFile, alternativeText, width, height } =
                content || {};

              // We need separate vars for each image or video
              // The CSS then applies the correct one with nth-child
              // This is used to scale the media elements so they have the same height and variable widths
              const aspectRatioKey = `--aspect-ratio-${index}`;
              aspectRatiosRef.current.push({
                [aspectRatioKey]:
                  strapi_component === 'simple.video-link'
                    ? video_cover?.width / video_cover?.height
                    : width / height,
              });

              return {
                'simple.image': (
                  <figure
                    className={`${imgWrapper}
                    ${width / height <= 1 ? portraitImg : ''}
                    
                    `}
                    style={aspectRatiosRef.current[index]}
                    key={index}
                  >
                    <WebFrame webFrame={frame} aspectRatio={width / height}>
                      {localFile && (
                        <GatsbyImage
                          image={getImage(localFile)}
                          alt={alternativeText ?? ''}
                        />
                      )}
                    </WebFrame>

                    {caption?.data.caption.length > 0 && (
                      <figcaption
                        className={`${figcaption} ${
                          lightBg ? 'textColorMidnight' : 'textColorMilk'
                        }`}
                      >
                        {parse(caption.data.caption, parseLinkOption)}
                        {/* {credit && (
                          <span className={`block meta`}>{credit}</span>
                        )} Removing extra credits since the caption field will contain credit info*/}
                      </figcaption>
                    )}
                  </figure>
                ),
                'simple.video-link': (
                  <figure
                    className={`${imgWrapper} ${
                      video_cover?.width / video_cover?.height <= 1
                        ? portraitImg
                        : ''
                    }`}
                    style={aspectRatiosRef.current[index]}
                    key={index}
                  >
                    <WebFrame
                      webFrame={frame}
                      aspectRatio={video_cover?.width / video_cover?.height}
                    >
                      <VideoPlayer
                        cover={video_cover}
                        url={link_content}
                        localVideoUrl={local_filename}
                        autoplay={autoplay}
                        isVr={is_vr}
                        useCoverSize
                      />
                    </WebFrame>
                    <figcaption>
                      <p className={`srOnly`}>{video_description}</p>
                    </figcaption>
                  </figure>
                ),
              }[strapi_component];
            }
          )}
        </div>
      </div>
    </div>
  );
};

export default MediaWrapper;
